import React from 'react';
import { motion } from 'framer-motion';

const ModernLoader = ({ message = "Loading...", size = 60 }) => {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000
    }}>
      {/* Modern Circle Spinner */}
      <div style={{ position: 'relative', marginBottom: '32px' }}>
        {/* Outer ring */}
        <motion.div
          style={{
            width: size,
            height: size,
            border: '3px solid rgba(96, 165, 250, 0.2)',
            borderRadius: '50%',
            position: 'absolute'
          }}
        />
        
        {/* Animated ring */}
        <motion.div
          style={{
            width: size,
            height: size,
            border: '3px solid transparent',
            borderTop: '3px solid #60a5fa',
            borderRight: '3px solid #a855f7',
            borderRadius: '50%'
          }}
          animate={{ rotate: 360 }}
          transition={{
            duration: 1,
            repeat: Infinity,
            ease: 'linear'
          }}
        />
        
        {/* Inner pulsing dot */}
        <motion.div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: size * 0.3,
            height: size * 0.3,
            background: 'linear-gradient(135deg, #ff6b35, #60a5fa)',
            borderRadius: '50%'
          }}
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.7, 1, 0.7]
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }}
        />
      </div>

      {/* Loading message */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        style={{
          color: 'white',
          fontSize: '1.2rem',
          fontWeight: '500',
          textAlign: 'center',
          marginBottom: '16px'
        }}
      >
        {message}
      </motion.div>

      {/* Animated dots */}
      <div style={{ display: 'flex', gap: '8px' }}>
        {[0, 1, 2].map((index) => (
          <motion.div
            key={index}
            style={{
              width: '8px',
              height: '8px',
              background: '#60a5fa',
              borderRadius: '50%'
            }}
            animate={{
              scale: [1, 1.5, 1],
              opacity: [0.5, 1, 0.5]
            }}
            transition={{
              duration: 1,
              repeat: Infinity,
              delay: index * 0.2,
              ease: 'easeInOut'
            }}
          />
        ))}
      </div>

      {/* Subtle background animation */}
      <div style={{
        position: 'absolute',
        inset: 0,
        opacity: 0.1,
        pointerEvents: 'none'
      }}>
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            style={{
              position: 'absolute',
              width: '2px',
              height: '2px',
              background: '#60a5fa',
              borderRadius: '50%',
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`
            }}
            animate={{
              opacity: [0, 1, 0],
              scale: [0, 1, 0]
            }}
            transition={{
              duration: 2 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 2
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ModernLoader;
